import React from "react";

const RecordingIcon = () => (
  <div className="container">
    <div className="circle" />
    <span>REC</span>
    <style jsx>{`
      span {
        font-size: 0.8rem;
        font-weight: bold;
        padding: 0 0 0 5px;
        color: white;
      }
      .container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      .circle {
        background: #fa3838;
        border-radius: 50%;
        height: 15px;
        width: 15px;
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
        transform: scale(1);
        animation: pulse 2s infinite;
      }

      @keyframes pulse {
        0% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
        }

        70% {
          transform: scale(1);
          box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
        }

        100% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }
      }
    `}</style>
  </div>
);

export default RecordingIcon;
